import type { RouteObject } from 'react-router';

import { personvelgerLoader } from '../../router/loader';
import Container from '../container';
import ErrorElement from '../error';
import Personvelger from './personvelger';

export const routes: RouteObject[] = [
  {
    path: '*',
    element: (
      <Container>
        <Personvelger />
      </Container>
    ),
    loader: personvelgerLoader,
    errorElement: (
      <Container>
        <ErrorElement />
      </Container>
    ),
  },
];
